import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the EnumsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
export enum ButtonTypes {
  DETAILS_BUTTON,
  DETAILS_CHILD,
  NONE,
  PARENT,
  ONE_TO_FIVE_PARENT,
  ONE_TO_FIVE_CHILD,
  BINARY_ONLY,
  COLOR_PARENT,
  COLOR_CHILD,
}

@Injectable({
    providedIn: 'root'
})
export class EnumsProvider {

  constructor(public http: HttpClient) {
    console.log('Hello EnumsProvider Provider');
  }
}
